export enum EFavoriteTab {
  COMPETITION = 0,
  MATCH = 1,
  TEAM = 2,
  // LOTTERY = 'LOTTERY',
}
